export enum InputTypeQuiz {
	Prompt = 'prompt',
	Url = 'url',
	File = 'file',
	Course = 'course'
}

export enum DifficultyLevelQuiz {
	Easy = 'Easy',
	Medium = 'Medium',
	Hard = 'Hard'
}